import React from 'react';
import Routes from './Routes';
import { Container, Image } from 'react-bootstrap';

const Home = () => {
  return (
    <Container>
      <div className="text-center mb-5 mt-3">
        <Image src="chic_main.png" fluid />
      </div>
      <h4 className="mb-3">Installation</h4>
      <p>With Node installed on your system</p>
      <code>{'npm install chic-ui'}</code>
      <h4 className="mb-3 mt-5">Components</h4>
      <Routes />
    </Container>
  );
};

export default Home;
